const getTextFromHtml = (htmlString: string) => {
  const str = htmlString || '';
  const regex = /<[^>]+>|&nbsp;/g;
  return str.replace(regex, '').trim();
};

export default getTextFromHtml;
